// removed by extract-text-webpack-plugin
module.exports = {"atheleteContainer":"Parent__atheleteContainer___26GRL","bannerAthelete":"Parent__bannerAthelete___wnzdF"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Parents/Parent.scss
// module id = 1579
// module chunks = 0